import { Theme } from "@emotion/react";
import { SxProps, TableRow } from "@mui/material";
import { ReactNode } from "react";
import generateUniqueId from "util/generate_id";
import TableCellComponent from "./TableCellComponent";

export interface DataHeaderType {
  label: string | ReactNode;
  sx?: SxProps<Theme>;
  rowSpan?: number;
  colSpan?: number;
  maxWidth?: string;
}

interface Props {
  data: DataHeaderType[];
  hiddenBorder?: boolean;
  type?: "header" | "body";
}

/**
 * TableRowComponent component renders a table row with a label and optional sx prop for styling.
 * @param {Object} props - The properties object.
 * @param {SxProps<Theme>} [props.sx] - Optional MUI sx prop for styling the table row.
 */
export default function TableRowComponent({ data, type, hiddenBorder }: Props) {
  return (
    <TableRow>
      {data.map((item, index) => (
        <TableCellComponent
          {...item}
          key={generateUniqueId(index)}
          type={type}
          hiddenBorder={hiddenBorder}
          sx={{
            ...item.sx,
            whiteSpace: "pre-line",
          }}
        />
      ))}
    </TableRow>
  );
}
